/* eslint-disable no-unused-vars */
import React, { ReactElement, useState } from 'react'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors } from '../../const/theme'
import {
  HeaderWrapper,
  CourseList,
  ProfileDropDown,
  ProfileWrapper,
  UserName,
  CourseInput,
  ProfileWrapper2,
  ProfileImage,
  ProfileData,
  LogoutIcon,
  LogoutButton
} from './subcomponents'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { handleLogout } from '../../redux/user/actions'
import DesktopMenu from './DesktopMenu'
import MobileMenu from './MobileMenu'
import useBreakpoint from 'use-breakpoint'
import BREAKPOINTS from '../../const/breakpoint'
import { RootState } from '../../redux/store'
import strings from '../../locale/en'
import { useLocation } from 'react-router-dom'
import ROUTES from '../../const/routes'
import { updateSelectedBatch } from '../../redux/user/actions'

const Header = (): ReactElement => {
  const { breakpoint } = useBreakpoint(BREAKPOINTS)
  const {
    userName = '',
    batchList = [],
    selectedBatchId = '',
    role
  } = useSelector(
    (state: RootState) => ({
      userName: state.user?.userInfo?.userDetail?.userName,
      role: state.user?.userInfo?.role,
      batchList: state.user?.userInfo?.userDetail?.batchList,
      selectedBatchId: state.user?.selectedBatch
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const {
    header: { logout }
  } = strings
  const location = useLocation()
  const showDropdown =
    location?.pathname === ROUTES.ASSESSMENT ||
    location?.pathname === ROUTES.PRACTICE_TEST
  const selectedBatch = batchList.filter(
    (batch) => batch?.id === selectedBatchId
  )
  const [show, setshow] = useState(false)
  return (
    <>
      <HeaderWrapper>
        {breakpoint === 'mobile' ? <MobileMenu /> : <DesktopMenu />}

        <ProfileWrapper>
          {showDropdown && (
            <CourseList>
              <CourseInput
                readOnly
                placeholder="Course List"
                aria-label="Course List"
                value={selectedBatch.length ? selectedBatch[0].batchName : ''}
              />
              <DropdownButton
                variant="outline-secondary"
                title=""
                id="course-id"
                align="end"
                onSelect={(eventKey) => {
                  const value = batchList[Number(eventKey)]?.id
                  dispatch(updateSelectedBatch(value))
                }}
              >
                {batchList.map((batch, index) => (
                  <Dropdown.Item eventKey={index} key={`course-${index}`}>
                    {batch?.batchName}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </CourseList>
          )}
          <ProfileWrapper2>
            <ProfileImage
              icon={['fas', 'user-circle']}
              size="2x"
              onClick={() => {
                setshow(!show)
              }}
            />
            {show && (
              <ProfileData className="profileData">
                <h3>{userName}</h3>
                <h4>{role?.toLowerCase()}</h4>
                <LogoutButton
                  onClick={() => {
                    dispatch(handleLogout())
                  }}
                >
                  <LogoutIcon icon={['fas', 'arrow-right-from-bracket']} />
                  {logout}
                </LogoutButton>
              </ProfileData>
            )}
          </ProfileWrapper2>
          {/* <ProfileDropDown>
            <Dropdown.Toggle variant="light" id="profile-dropdown">
              <UserName>{userName}</UserName>
              <FontAwesomeIcon
                icon={['fas', 'user-circle']}
                size="2x"
                color={colors.purple}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => {
                  dispatch(handleLogout())
                }}
              >
                {logout}
              </Dropdown.Item>
            </Dropdown.Menu>
          </ProfileDropDown> */}
        </ProfileWrapper>
      </HeaderWrapper>
    </>
  )
}

export default Header
